var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPataBranca(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 74,
    viewBox: "0 0 79 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.219 20.1124C28.5548 29.9029 19.7884 46.4136 8.167 42.1765C3.15474 40.3491 0.275317 35.1592 0.208216 29.8419C0.0538123 17.5614 13.0631 11.7049 20.219 20.1124Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3632 26.2511C17.5084 21.5644 22.1079 -0.743166 35.7096 0.272743C41.9063 0.736087 46.7155 6.79874 45.9729 14.4054C45.1429 22.9321 37.5899 28.8859 30.3632 26.2511Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6307 64.6665C20.6069 64.8448 23.8983 65.6955 27.2325 66.8607C30.758 68.0896 34.331 69.6684 36.4513 71.1638C42.1736 75.2133 52.5739 74.2556 54.1338 64.9599C55.5748 56.3661 49.028 54.4986 50.5673 46.4175C52.1277 38.2521 47.7199 32.4298 41.8758 30.6286C36.4668 28.9622 29.8277 30.7421 25.563 37.3031C21.0205 44.2952 14.8545 41.5227 9.87469 48.8234C4.47531 56.7271 11.557 64.0329 18.6307 64.6665Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.987 34.5004C49.3509 33.1747 47.0454 30.0138 46.5611 26.2859C45.1223 15.2014 58.7441 5.54887 67.3137 11.804C78.1545 19.7106 65.8347 39.1846 52.987 34.5004Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1034 50.7073C52.8845 39.5312 67.4427 31.2848 75.2843 38.4086C84.7303 46.989 71.9625 64.4879 59.5868 59.9759C55.6152 58.5278 53.1864 54.9558 53.1034 50.7073Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPataBranca);
export default __webpack_public_path__ + "static/media/PataBranca.5b81e1062aafb24586940ae2a5687609.svg";
export { ForwardRef as ReactComponent };